<template lang='pug'>
  div.above-the-fold
    div.above-the-fold-relative
      v-container(fluid v-if='$vuetify.breakpoint.lgAndUp').bionic-container
        v-row.full-height(align='center')
          v-col.above-sparkline(cols='7')
            .bionic-metrics-text.font-weight-thin.bionic-metrics-text Bionic Metrics
            .display-1.font-weight-light.grey--text.text--darken-1 The evolution of software automation testing tools
            div.above-sparkline.mt-2
              v-btn(large dark color='accent' @click='goToTrial') Request Trial
          v-col(cols='5')
            div.bionic-metrics-video
              video(autoplay loop muted width='100%')
                source(src='https://assets.bionicmetrics.com/bionic/demo.mp4')
          v-sparkline.sparkline(v-if='delay' :value='value' :gradient='gradient' smooth='10' :padding='padding' :line-width='1.5' :stroke-linecap='lineCap' :gradient-direction='gradientDirection' auto-draw)
      v-container(fluid v-if='!$vuetify.breakpoint.lgAndUp').bionic-container-small
        v-row(align='center').text-center
          v-col.above-sparkline.mb-20
            .display-2.font-weight-thin Bionic Metrics
            .subtitle-1.font-weight-light.grey--text The evolution of software automation testing tools
            div.above-sparkline
              v-btn(large dark color='accent' @click='goToTrial') Request Trial
        v-sparkline.sparkline(v-if='delay' :value='value' :gradient='gradient' smooth='10' :padding='padding' :line-width='4' :stroke-linecap='lineCap' :gradient-direction='gradientDirection' auto-draw)
    v-row(v-if='!$vuetify.breakpoint.lgAndUp' justify='center' align='center')
      v-col(cols='10' lg='8' align='center')
        div.bionic-metrics-video-small
          video(autoplay loop muted width='100%')
            source(src='https://assets.bionicmetrics.com/bionic/demo.mp4')


</template>

<script>
import RequestTrialButton from './RequestTrialButton';

export default {
  name: 'AboveFold',
  components: {RequestTrialButton},
  mounted() {
    setTimeout(this.triggerDelay, 2000);
  },
  methods: {
    goToTrial() {
      this.$vuetify.goTo('#requestTrialSection');
    },
    triggerDelay() {
      this.delay = true;
    }
  },
  data() {
    return {
      delay: false,
      width: 1,
      radius: 10,
      padding: 0,
      lineCap: 'round',
      // gradient: ['#80DEEA', '#00E676'],
      gradient: ['#00E676', '#082543'],
      value: [-5, -12, 5, -4, 7, 6, 5, 20, 2, 14, 11, 18, 22, 20, 30, 35, 40, 50, 70, 55, 90, 85, 110, 75, 150],
      gradientDirection: 'right'
    };
  }
};
</script>

<!-- Add 'scoped" attribute to limit CSS to this component only -->
<style lang='scss'>
  .above-the-fold {
    position: relative;
    padding-bottom: 10vmin;
    background: linear-gradient(180deg, #ffffff, #ECEFF1);
    background-repeat: no-repeat;
  }

  .above-the-fold-relative {
    position: relative;
  }

  .bionic-container {
    min-height: 70vmin;
    height: 70vmin;
    text-align: center;
  }

  .sparkline {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
  }

  .above-sparkline {
    z-index: 1;
  }

  .image {
    width: 100%;
  }

  .bionic-metrics-video {
    background: #fff;
    border-radius: 8px;
    position: relative;
    z-index: 5;
    overflow: hidden;
    width: 45vmin;
    /*height: 35vmin;*/
    display: block;
    -webkit-transform-origin: top;
    transform-origin: top;
    -webkit-box-shadow: 1px 1px 5px 0 rgba(26, 26, 67, .05), 39px 62.5px 125px -25px rgba(50, 50, 93, .5), 23.4px 37.5px 75px -37.5px rgba(0, 0, 0, .6);
    box-shadow: 1px 1px 5px 0 rgba(26, 26, 67, .05), 39px 62.5px 125px -25px rgba(50, 50, 93, .5), 23.4px 37.5px 75px -37.5px rgba(0, 0, 0, .6);
    -webkit-transform: scale(1.3) translateX(50px) translateY(0) perspective(3190px) rotateY(-29deg) rotateX(4deg) rotate(1deg);
    transform: scale(1.3) translateX(50px) translateY(0) perspective(3190px) rotateY(-29deg) rotateX(4deg) rotate(1deg);
  }

  .bionic-metrics-video-small {
    background: #fff;
    border-radius: 8px;
    position: relative;
    z-index: 5;
    overflow: hidden;
    width: 90%;
    /*height: 35vmin;*/
    display: block;
    -webkit-box-shadow: 0 30px 60px -12px rgba(50, 50, 93, .25), 0 18px 36px -18px rgba(0, 0, 0, .3), 0 -12px 36px -8px rgba(0, 0, 0, .025);
    box-shadow: 0 30px 60px -12px rgba(50, 50, 93, .25), 0 18px 36px -18px rgba(0, 0, 0, .3), 0 -12px 36px -8px rgba(0, 0, 0, .025);
    -webkit-transform-origin: top center;
    transform-origin: top center;
    -webkit-transform: perspective(3190px);
    transform: perspective(3190px);
  }

  .bionic-metrics-text {
    font-size: 80px;
  }

  .mb-20 {
    margin-bottom: 20vh;
  }

  .bionic-metrics-text {
    color: #082543
  }
</style>
